import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Si el email existe, recibirás instrucciones (revisa logs en demo)");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen paprika-bg flex items-center justify-center p-6">
      <Card className="w-full max-w-md p-8 rounded-2xl shadow-xl border-stone-200">
        <h2 className="text-2xl font-heading font-bold text-stone-900">Recuperar contraseña</h2>
        <p className="mt-2 text-stone-600 text-sm">Te enviaremos un enlace de recuperación.</p>
        {sent ? (
          <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg text-sm text-green-700">
            Si el email está registrado, recibirás un enlace de recuperación. En la versión demo el enlace se muestra en los logs del servidor.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label>Email</Label>
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="input-forgot-email" className="mt-1.5" />
            </div>
            <Button type="submit" disabled={busy} className="w-full bg-primary hover:bg-primary-hover" data-testid="btn-forgot-submit">
              Enviar enlace
            </Button>
          </form>
        )}
        <div className="mt-6 text-center text-sm">
          <Link to="/login" className="text-primary hover:underline">Volver a iniciar sesión</Link>
        </div>
      </Card>
    </div>
  );
}
